import {
  TrendingUpIcon,
  ClockIconV2,
  DollarIcon,
  UserIcon,
  PersonIcon,
  TrendingUpIcon2,
  PeopleIcon,
  CalendarIcon,
  CheckIcon,
  ClockIcon,
  WarningIcon,
} from "../../../images/icons/icons";
import { convertThenFormat } from "../../common-data/Converts";

export const HIGHLIGHTED_KEYS = [
  "lead_value_added_today",
  "lead_values",
  "lead_values_converted",
  //   "all_leads",
  "all_follow_ups",
];

export const ALERT_KEYS = [
  "closure_expected_today",
  "missed_followups",
  "todays_follow_ups",
  "tomorrows_follow_ups",
];

export const EXCLUDED_KEYS = [
  "first_call_missed",
  "first_call",
  "total_walkins",
  "total_walkins_today",
  "lead_values",
  "lead_values_converted",
  "lead_value_added_today",
  // "lead_values_converted_today",
  "pending_leads",
  "hot_leads",
  "semi_hot_leads",
  "warm_leads",
  "cold_leads",
  "hot_missed",
  "closure_expected_today",
  "closure_expected_tomorrow",
  "todays_follow_ups",
  "missed_followups",
  "tomorrows_follow_ups",
  "one_day_membership_completed",
  "one_day_membership_pending",
  "lead_values",
  "lead_values_converted",
  "all_leads",
  "all_follow_ups",
  // "self_assigned",
  // "assigned_by_others",
  // "followups_added_today",
  "converted_leads",
  "todays_leads",
];

export const getCardLabel = (key) => {
  switch (key) {
    case "lead_values":
      return "Total Lead Value";
    case "lead_values_converted":
      return "Total Converted Value";
    case "all_leads":
      return "Total Leads";
    case "all_follow_ups":
      return "Total Follow-ups";
    case "missed_followups":
      return "Missed Follow-ups";
    case "todays_follow_ups":
      return "Today's Follow-ups";
    case "tomorrows_follow_ups":
      return "Tomorrow's Pipeline";
    case "followups_added_today":
      return "Follow-ups Added Today";
    default:
      return key.replace(/_/g, " ");
  }
};

export const getCardSubLabel = (key, statsData) => {
  switch (key) {
    case "lead_values":
      return `${statsData?.data?.all_leads || 0} leads`;
    case "lead_values_converted":
      return `${statsData?.data?.converted_leads || 0} leads`;
    // case "lead_values_converted":
    //   return `₹${convertThenFormat(
    //     statsData?.data?.lead_values_converted_today || 0
    //   )} today`;
    case "lead_value_added_today":
      return `${statsData?.data?.todays_leads || 0} leads`;
    case "all_leads":
      return `${statsData?.data?.converted_leads || 0} converted`;
    case "all_follow_ups":
      return `${statsData?.data?.missed_followups || 0 || 0} missed`;
    case "closure_expected_today":
      return `₹${convertThenFormat(
        statsData?.leadTypeValues?.closure_expected_today_value || 0
      )}  Immediate attention required`;
    case "missed_followups":
      return `₹${convertThenFormat(
        statsData?.leadTypeValues?.missed_followups_value || 0
      )} potential loss`;
    case "todays_follow_ups":
      return `₹${convertThenFormat(
        statsData?.leadTypeValues?.todays_follow_ups_value || 0
      )} Scheduled for today`;
    case "tomorrows_follow_ups":
      return `₹${convertThenFormat(
        statsData?.leadTypeValues?.tomorrows_follow_ups_value || 0
      )} Scheduled for tomorrow`;
    default:
      return null;
  }
};

export const getCardValue = (key, value) => {
  switch (key) {
    case "lead_values":
      return `₹${convertThenFormat(value || 0)}`;
    case "lead_values_converted":
      return `₹${convertThenFormat(value || 0)}`;
    case "lead_value_added_today":
      return `₹${convertThenFormat(value || 0)}`;
    case "lead_values_converted_today":
      return `₹${convertThenFormat(value || 0)}`;
    default:
      return `${value || 0}`;
  }
};

export const getCardIcon = (key) => {
  switch (key) {
    case "lead_values":
      return <DollarIcon />;
    case "lead_values_converted":
      return <TrendingUpIcon />;
    case "all_leads":
      return <UserIcon />;
    case "all_follow_ups":
      return <ClockIconV2 />;
    case "lead_values_converted_today":
      return <TrendingUpIcon2 color="#fff" />;
    case "closed_leads":
      return <PeopleIcon color="#fff" />;
    case "followups_added_today":
      return <CalendarIcon color="#fff" />;
    case "upcoming_follow_ups":
      return <WarningIcon color="#fff" />;
    case "self_assigned":
      return <PersonIcon />;
    case "assigned_by_others":
      return <PeopleIcon />;
    default:
      return <PersonIcon />;
  }
};

export const getCardBg = (key) => {
  switch (key) {
    case "lead_values":
      return "blue";
    case "lead_values_converted":
      return "green";
    case "lead_value_added_today":
      return "purple";
    case "all_leads":
      return "purple";
    case "all_follow_ups":
      return "orange";
    case "closure_expected_today":
      return "#fef2f2";
    case "missed_followups":
      return "#fff7ed";
    case "todays_follow_ups":
      return "#eff6ff";
    case "tomorrows_follow_ups":
      return "#f0fdf4";
    default:
      return "white";
  }
};

export const getCardText = (key) => {
  switch (key) {
    case "closure_expected_today":
      return "#dc2626";
    case "missed_followups":
      return "#ea580c";
    case "todays_follow_ups":
      return "#2563eb";
    case "tomorrows_follow_ups":
      return "#16a34a";
    default:
      return "#000";
  }
};

export const getFilterType = (key) => {
  switch (key) {
    case "all_leads":
      return "all";
    case "lead_values_converted":
      return "converted";
    case "closed_leads":
      return "closed";
    case "lead_value_added_today":
      return "today_added_lead_value";
    default:
      return key;
  }
};
